module.exports = __webpack_public_path__ + "img/momo_title_redeem_record.0fdb0514.png";